import React from 'react';
import styled from '@emotion/styled';

type HrProps = { color: string, thickness: string };

function Hr({ color, thickness}: HrProps) {
  return (
    <HrStyle color={color} thickness={thickness}/>
  )
}

export default Hr;

const HrStyle = styled.hr<{ color: string, thickness: string }>`
  border-top: ${({ thickness }) => thickness} solid ${({ color }) => color};`;